import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import type { ReportRefItemType } from 'types/api/quizReportRefResponseType';

import '../../assets/styles/ws-report.scss';
import { useWsReportChart } from './useWsReportChart';
import type { ChartType } from './wsReportChart.utils';

import type { JSX } from 'react';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend
);

const CHART_BUTTONS: { type: ChartType; label: string }[] = [
  { type: 'participatedCount', label: '参加数' },
  { type: 'mailAddressCount', label: '獲得リスト数' },
  { type: 'mailAddressAcquisitionRate', label: 'リスト獲得率' },
  { type: 'answeredCount', label: '完了数' },
  { type: 'answeredRate', label: '完了率' },
];

/**
 * レポートチャート描画コンポーネント
 */
export default function WsReportChart(props: {
  reports: ReportRefItemType[];
  lineFlag: boolean;
}): JSX.Element {
  const { initialized, chartType, chartData, chartOptions, chartRef, onChangeChartType } =
    useWsReportChart(props.reports, props.lineFlag);

  return (
    <>
      {initialized && chartData && chartOptions && (
        <section className="section-chart">
          <div className="container">
            <div className="card card-chart">
              <div className="card-header">
                <ul className="list-unstyled list-inline list-badge mb-0">
                  {CHART_BUTTONS.map(({ type, label }) => (
                    <li key={type} className="list-inline-item">
                      <button
                        onClick={() => onChangeChartType(type)}
                        className={`btn btn-simple ${chartType === type ? type : 'gray'}`}
                        type="button"
                      >
                        {label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="card-body pt-3">
                <Line
                  ref={chartRef}
                  data={chartData}
                  options={chartOptions}
                  redraw={true}
                  style={{ maxHeight: '500px' }}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
